import { FormFieldModel } from '@alfresco/adf-core';
import { Injectable } from '@angular/core';
import { BaseProcessor } from '../../base.processor';
import { ReiseAufVariables } from "../reise-auf.variables";

@Injectable({ providedIn: 'root' })
export class ReiseAufFreigabeProcessor extends BaseProcessor {
  static FORM_NAME = 'reiseAufFreigabe';
  public readonly FORM_NAME = ReiseAufFreigabeProcessor.FORM_NAME;

  public onFieldValueChange(field: FormFieldModel) {
    if (field.id === ReiseAufVariables.freigabe) {
      field.form.validateForm();
    }
  }
}
